export const onEnter =
    <E extends HTMLElement, T extends (e: React.SyntheticEvent<E>) => void>(
        callback: T,
    ) =>
    (e: React.KeyboardEvent<E>) => {
        if (e.key === 'Enter') {
            callback(e);
        }
    };
